<template>
    <div class="detail-info-header mobile" v-if="isMobileSize">
        <div class="info" :class="{ sold: info.listingStatus == 'Sold' }">
            <div class="price-caculator">
                <price class="price" />
                <caculator v-if="!hideCalculator" class="caculator" />
            </div>
            <div class="button" :class="{ sold: info.listingStatus == 'Sold' }">
                <tour-button />
            </div>
        </div>
        <count class="count" />
    </div>
    <div class="detail-info-header pc" v-else>
        <div class="info" :class="{ sold: info.listingStatus == 'Sold' }">
            <div class="price-caculator">
                <price class="price" />
                <caculator v-if="!hideCalculator" class="caculator" />
            </div>
            <count class="count" />
        </div>
        <div class="button" :class="{ sold: info.listingStatus == 'Sold' }">
            <tour-button />
        </div>
    </div>
</template>

<script>
import { mapState } from '@/store/helpers';
import caculator from './caculator.vue';
import count from './count.vue';
import price from './price.vue';
import TourButton from './tour-button.vue';

export default {
    components: { caculator, count, price, TourButton },
    data: function() {
        return {};
    },
    computed: {
        ...mapState({
            "info": store => store.listingDetail.info || {}
        }),
        isMobileSize() {
            return this.platform.isMobile;
        },
        hideCalculator() {
            return (
                this.info.purchaseType == 'For Rent' ||
                this.info.statusOrigin == 'Leased'
            );
        }
    }
};
</script>
<style lang="scss">
@import '../../../../theme/mixin.scss';
@import '../../../../theme/media.scss';

.detail-info-header {
    &.pc {
        display: flex;
        padding-bottom: 20px;
        border-bottom: 1px solid #eaeaea;
        .info {
            width: 70%;
            flex: 1;
            &.sold {
                width: 80%;
                .price-caculator {
                    .caculator {
                        display: inline-block;
                        margin-left: 20px;
                        height: 28px;
                        position: static;
                    }
                }
            }
            .price-caculator {
                position: relative;
                .price {
                    display: inline-block;
                }
                .caculator {
                    display: inline-block;
                    position: absolute;
                    bottom: 10px;
                }
            }
            .count {
                margin-top: 13px;
            }
        }
        .button {
            .tour-btn-container {
                .btn-item {
                    width: auto;
                }
            }
            &.sold {
                width: 20%;
                .tour-btn-container {
                    .btn-item {
                        padding-top: 25px;
                    }
                }
            }
        }
    }
    &.mobile {
        padding-bottom: 20px;
        border-bottom: 1px solid #eaeaea;
        .info {
            display: flex;
            .price-caculator {
                width: 70%;
                .price {
                }
                .caculator {
                    display: inline-block;
                }
            }
            .button {
                width: 30%;
                .tour-btn-container {
                    .btn-item {
                        padding-top: 5px;
                    }
                }
            }
        }
        .count {
            margin-top: 30px;
        }
    }
}
</style>
